import React from "react";
import { Show } from "../../../layout/responsive/index.js";
import { useRenameCSS } from "../../../theme/Theme.js";
import { Detail } from "../../../typography/index.js";
import { useId } from "../../../util/hooks/index.js";
import { useDateTranslationContext } from "../../Date.locale.js";
import { DatePickerWeekNumber } from "./DatePicker.WeekNumber.js";
const DatePickerWeekRow = ({ onWeekNumberClick, weeks, }) => {
    const translate = useDateTranslationContext().translate;
    const { cn } = useRenameCSS();
    const labelId = useId();
    if (!onWeekNumberClick) {
        return null;
    }
    return (React.createElement(Show, { below: "sm", asChild: true },
        React.createElement("table", { className: "rdp-table", role: "grid" },
            React.createElement("tbody", { className: "rdp-tbody" },
                React.createElement("tr", { className: cn("rdp-row navds-date__week-row") },
                    React.createElement(Detail, { as: "th", weight: "semibold", className: cn("rdp-cell navds-date__week-cell") },
                        React.createElement("span", { className: cn("navds-date__week-wrapper"), id: labelId }, translate("week"))), weeks === null || weeks === void 0 ? void 0 :
                    weeks.map((week) => (React.createElement(DatePickerWeekNumber, { key: week.weekNumber, week: week, onWeekNumberClick: onWeekNumberClick, showOnDesktop: false, className: cn("navds-date__week-wrapper") }))))))));
};
export { DatePickerWeekRow };
//# sourceMappingURL=DatePicker.WeekRow.js.map